import './index.css'

import { QueryClientProvider } from '@tanstack/react-query'
import { initFirebase } from '@zealth/core/firebase/runtime'
import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App'
import { firebaseConfig } from './firebase'
import { queryClient } from './queryClient'
import { initSentry, Sentry } from './sentry'

initSentry()
initFirebase(firebaseConfig)

// HeroUI v3 needs no provider: the theme is CSS, imported in index.css.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)
